import { topicCategories } from "@/mocks/hotlist";

const TONE_MAP: Record<string, { bg: string; text: string; border: string }> = {
  primary: {
    bg: "bg-primary-500/10",
    text: "text-primary-400",
    border: "border-primary-500/25",
  },
  accent: {
    bg: "bg-accent-500/10",
    text: "text-accent-400",
    border: "border-accent-500/25",
  },
  secondary: {
    bg: "bg-secondary-500/10",
    text: "text-secondary-400",
    border: "border-secondary-500/25",
  },
};

export default function TopicCategories() {
  return (
    <section id="topics" className="w-full py-16 md:py-24 bg-background-100 border-y border-background-200/70">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="mb-10 md:mb-12">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-400 font-medium">
              <span className="w-6 h-px bg-primary-500" />
              话题分类
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              按兴趣挑一个方向
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
              八个常驻分类覆盖娱乐、综艺、影视、电竞、网红、社会、消费与情感话题，每个分类都按更新频率持续归档。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {topicCategories.map((cat) => {
              const tone = TONE_MAP[cat.tone];
              return (
                <article
                  key={cat.name}
                  className="group rounded-lg border border-background-200/70 bg-background-50 p-5 flex flex-col hover:border-background-300 transition-colors"
                >
                  <span
                    className={`w-12 h-12 rounded-lg ${tone.bg} border ${tone.border} flex items-center justify-center`}
                  >
                    <i className={`${cat.icon} text-2xl ${tone.text}`} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                    {cat.name}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                    {cat.desc}
                  </p>
                  <div className="mt-4 pt-3 border-t border-background-200/60 flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{cat.count}</span>
                    <a
                      href="#ranking"
                      className={`inline-flex items-center gap-1 text-xs ${tone.text} whitespace-nowrap cursor-pointer`}
                    >
                      进入
                      <i className="ri-arrow-right-line" />
                    </a>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}